"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSlackMessage = exports.serializeSlackMessage = void 0;
const serializeSlackMessage = (item) => {
    return typeof item.data.channelId === "string" ? item.data.channelId : "";
};
exports.serializeSlackMessage = serializeSlackMessage;
const validateSlackMessage = (item) => {
    if (!item.required || item.data.channelId) {
        return { valid: true };
    }
    return {
        valid: false,
        error: { message: "Please select a valid Slack Channel" },
    };
};
exports.validateSlackMessage = validateSlackMessage;
//# sourceMappingURL=slackMessage.js.map